import React from "react";
import styled from "styled-components";
import { Radio } from "components/common";
import { strategiesLabels } from "views/logic/valueactions/createEventDefinition/Constants";
const Container = styled.div`
  display: flex;
  gap: 5px;
  align-items: baseline;
`;
const RadioSection = ({ strategy, onChange, strategyAvailabilities }) => {
  const { description } = strategiesLabels[strategy];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("b", null, "Strategy by:"), /* @__PURE__ */ React.createElement(Container, null, Object.entries(strategiesLabels).map(([curStrategy, { label }]) => {
    if (!strategyAvailabilities[curStrategy]) return null;
    return /* @__PURE__ */ React.createElement(
      Radio,
      {
        id: curStrategy,
        key: curStrategy,
        name: "strategy",
        value: curStrategy,
        checked: curStrategy === strategy,
        onChange
      },
      label
    );
  })), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, "Description: "), /* @__PURE__ */ React.createElement("i", null, description)));
};
export default RadioSection;
